/**
 *  File that can be loaded in each page as a mixin, handles generic stuff for keycloak functions
 */
import {keycloak as Keycloak} from "@/main.js";
import keycloakConstants from "../constants/keycloakConstants";
import { Leden } from "@/api/data";

 export const keycloakMixin = {
    data() {
        return {
            sub:  Keycloak.tokenParsed.sub
        }
    },
    methods: {
        isHDNAdmin(){
            return this.getUserRole() === keycloakConstants.HDN_ADMIN;
        },
        isHDNInzage(){
            return this.getUserRole() === keycloakConstants.HDN_INZAGE;
        },
        isORGAdmin(){
            return this.getUserRole() === keycloakConstants.ORG_ADMIN;
        },
        isContactpersonenBeheerder(){
            return Keycloak?.tokenParsed?.resource_access?.[keycloakConstants.USERMANAGEMENT_REALM_NAME]?.roles?.includes(keycloakConstants.CONTACTPERSONEN_ADMIN)
        },
        isAutorisatieBeheerder(){
            return Keycloak?.tokenParsed?.resource_access?.[keycloakConstants.USERMANAGEMENT_REALM_NAME]?.roles?.includes(keycloakConstants.AUTORISATIE_ADMIN)
        },
        isMachtigingenBeheerder(){
            return Keycloak?.tokenParsed?.resource_access?.[keycloakConstants.USERMANAGEMENT_REALM_NAME]?.roles?.includes(keycloakConstants.MACHTIGINGEN_ADMIN)
        },
        isDocumentatieinzage(){
            return Keycloak?.tokenParsed?.resource_access?.[keycloakConstants.USERMANAGEMENT_REALM_NAME]?.roles?.includes(keycloakConstants.DOCUMENTATION_ACCESS)
        },
        isFacturatieGegevensBeheerder(){
            return Keycloak?.tokenParsed?.resource_access?.[keycloakConstants.USERMANAGEMENT_REALM_NAME]?.roles.includes(keycloakConstants.FACTURATIE_GEGEVENS_BEHEER)
        },
        isFacturatieGegevensInzageUser(){
            return Keycloak?.tokenParsed?.resource_access?.[keycloakConstants.USERMANAGEMENT_REALM_NAME]?.roles.includes(keycloakConstants.FACTURATIE_GEGEVENS_INZAGE)
        },
        isUitzonderingenBeheerder(){
            return Keycloak?.tokenParsed?.resource_access?.[keycloakConstants.USERMANAGEMENT_REALM_NAME]?.roles.includes(keycloakConstants.UITZONDERINGENLIJST_ADMIN)
        },
        getUserRole(){
            let userRole = null;

            if (!Keycloak?.tokenParsed?.resource_access?.[keycloakConstants.USERMANAGEMENT_REALM_NAME]?.roles) {
                //If there are no roles, unnecessary to loop over roles
                return null;
            }

            for(let element of Keycloak?.tokenParsed?.resource_access?.[keycloakConstants.USERMANAGEMENT_REALM_NAME]?.roles) {
                if(element === keycloakConstants.HDN_ADMIN) {
                    userRole = keycloakConstants.HDN_ADMIN;
                    //HDN_ADMIN is the highest role so no need to check other roles
                    break;
                }

                if(element === keycloakConstants.HDN_INZAGE) {
                    userRole = keycloakConstants.HDN_INZAGE;
                    break;
                }

                if(element === keycloakConstants.ORG_ADMIN) {
                    userRole = keycloakConstants.ORG_ADMIN;
                }
            }

            return userRole;
        },


        async getMemberId(){

            let memberName = Keycloak.tokenParsed.groups[0].split('/')[1];
            let members = await Leden.getMembers();


            let memberId = null;

            for (const member of members) {
                if (member.name === memberName) {
                    memberId = member.id;
                }
            }

            return memberId;
        }
    }
}